import { BarChart3, CalendarDays, ChevronRight, HandCoins, LayoutDashboard, LogOut, PackageSearch, PanelLeftClose, PanelLeftOpen, ReceiptText, Scissors, ShieldCheck, CreditCard, Landmark, Users, WalletCards } from "lucide-react";
import { useState } from "react";
import { NavLink, Outlet } from "react-router-dom";
import Brand from "../components/Brand";
import { useAuth } from "../context/AuthContext";

const links = [
  ["/backoffice", "Resumen", LayoutDashboard, true],
  ["/backoffice/catalogo", "Catalogo", PackageSearch],
  ["/backoffice/equipo", "Equipo", Scissors],
  ["/backoffice/asistencia", "Asistencia", CalendarDays],
  ["/backoffice/usuarios", "Usuarios", ShieldCheck],
  ["/backoffice/ventas", "Ventas", ReceiptText],
  ["/backoffice/reportes", "Reportes", BarChart3],
  ["/backoffice/pagos-personal", "Pagos personal", HandCoins],
  ["/backoffice/metodos-pago", "Metodos de pago", CreditCard, false, true],
  ["/backoffice/caja", "Caja diaria", Landmark, false, true],
  ["/backoffice/gastos", "Gastos", WalletCards, false, true],
  ["/backoffice/intereses-pago", "Intereses por pagar", HandCoins, false, true],
  ["/backoffice/turnos", "Turnos clientes", CalendarDays],
  ["/backoffice/clientes", "Clientes", Users],
];

export default function BackofficeLayout() {
  const { user, logout } = useAuth();
  const [collapsed, setCollapsed] = useState(false);
  return <div className="min-h-screen bg-zinc-200 lg:flex">
    <aside className={`bg-ink p-5 transition-all lg:fixed lg:inset-y-0 lg:flex lg:flex-col lg:p-7 ${collapsed ? "lg:w-24" : "lg:w-64"}`}><div className="flex items-center justify-between"><Brand compact={collapsed}/><button onClick={() => setCollapsed(!collapsed)} className="hidden text-zinc-500 hover:text-white lg:block">{collapsed ? <PanelLeftOpen/> : <PanelLeftClose/>}</button></div><nav className="mt-8 flex gap-2 overflow-x-auto pb-1 lg:min-h-0 lg:flex-1 lg:flex-col lg:overflow-x-hidden lg:overflow-y-auto scrollbar-hidden lg:space-y-2 lg:pb-2">{links.filter(([, , , , adminOnly]) => !adminOnly || user?.rol === "administrador").map(([to, label, Icon, end]) => <NavLink title={label} end={end} key={to} to={to} className={({ isActive }) => `flex min-w-fit items-center gap-3 rounded-xl px-4 py-3 text-sm font-bold transition ${isActive ? "bg-barberRed text-white" : "text-zinc-400 hover:bg-white/5 hover:text-white"}`}><Icon className="shrink-0" size={18} />{!collapsed && label}{!collapsed && <ChevronRight className="ml-auto hidden lg:block" size={14} />}</NavLink>)}</nav><div className="mt-8 shrink-0 border-t border-white/10 pt-5 lg:mt-5">{!collapsed && <><p className="truncate text-sm font-bold text-white">{user?.username}</p><p className="mb-3 text-[10px] uppercase tracking-widest text-barberGold">{user?.rol}</p></>}<button title="Cerrar sesion" onClick={logout} className="flex items-center gap-2 text-xs font-bold uppercase text-zinc-500 hover:text-white"><LogOut size={15}/>{!collapsed && "Cerrar sesion"}</button></div></aside>
    <main className={`min-w-0 flex-1 transition-all ${collapsed ? "lg:ml-24" : "lg:ml-64"}`}><div className="mx-auto max-w-[1500px] p-4 md:p-8 lg:p-10"><Outlet /></div></main>
  </div>;
}











